import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { ActivationFindProductComponent } from '@src/base-components/activation/steps/find-product/activation-find-product';
import { WizardFindSerializableProductComponentMessika } from '@src/clients/messika/wizard/find-product/wizard-find-serializable-product';
import { WizardFindNotSerializableProductComponentMessika } from '@src/clients/messika/wizard/find-product/wizard-find-not-serializable-product';


@Component({
    selector: 'app-activation-find-product-messika',
    templateUrl: './activation-find-product.html'
})
export class ActivationFindProductComponentMessika extends ActivationFindProductComponent {
    @ViewChild(WizardFindSerializableProductComponentMessika) wizardFindProductComponent: WizardFindSerializableProductComponentMessika;
    @ViewChild(WizardFindNotSerializableProductComponentMessika) wizardFindNotSerializableProductComponent: WizardFindNotSerializableProductComponentMessika;
}
